export const isOwnerOf = ( room, account, user ) => {
	const checkAgainst = typeof user !== 'undefined'
		? [user.props.id]
		: account
			? account.userids : []
	return room.props.owners.filter( ( userid ) => checkAgainst.includes( userid ) ).length !== 0
}
export const isModOf = ( room, account, user ) => {
	const checkAgainst = typeof user !== 'undefined'
		? [user.props.id]
		: account
			? account.userids : []
	return room.props.mods.filter( ( userid ) => checkAgainst.includes( userid ) ).length !== 0
}

export default {
	isOwnerOf: isOwnerOf,
	isModOf: isModOf
}
